// A link that starts a game. An address may carry a game to play (`play`,
// `on`): the room wrote those while playing asked for an account, and a link
// kept from then still starts its game. Nothing in the room needs an account
// before it opens but making an app, which asks in its own box.

import { DEVICE_IDS, type DeviceId } from "./types.ts";

/** A game an address asks the room to start. */
export interface Wanted {
  kind: "play";
  app: string;
  device?: DeviceId;
}

const PARAMS = ["play", "on"] as const;
/** App ids are made by the server: lowercase letters, digits and hyphens. */
const ID = /^[a-z0-9][a-z0-9-]{0,63}$/;
const device = (value: string | null): DeviceId | undefined => DEVICE_IDS.find((id) => id === value);

/** `url` without the game it carried. */
export function forget(url: URL): URL {
  const next = new URL(url);
  for (const name of PARAMS) next.searchParams.delete(name);
  return next;
}

/** What an address carries, or null. A value that is no id or no device is not acted on. */
export function recall(query: URLSearchParams): Wanted | null {
  const play = query.get("play");
  if (play === null || !ID.test(play)) return null;
  const on = device(query.get("on"));
  return { kind: "play", app: play, ...(on ? { device: on } : {}) };
}
